import PACKAGE_VERSION from './version'

export default [`Meilisearch mini-dashboard (v.${PACKAGE_VERSION})`]
